import { getEnvVar } from '../config';

/**
 * EPP (C-SW Middleware) feature flag - RLCS-2409 / RLCS-2216.
 *
 * Runtime-configurable via the Helm-injected VITE_EPP_ENABLED env var. Like the
 * other VITE_ flags in this app, the value is read at container startup: the
 * built bundle carries the placeholder "epp_enabled_placeholder", and the
 * .docker/env.sh entrypoint sed-replaces it with $VITE_EPP_ENABLED before nginx
 * serves the files. getEnvVar also falls back to import.meta.env for local dev,
 * so a local .env override keeps working.
 *
 * When disabled, the entire EPP surface (tab, selector option) is hidden so
 * general users never see it - EPP is specific to NA operators.
 *
 * NOTE: customer/tech are NOT frontend config. nii-backend owns EPP identity
 * (EPP_CUSTOMER + per-customer API key, tech defaulted to lte,nr). The FE only
 * toggles visibility and sends kind=epp with the selected ENM endpoint id(s).
 */
export const EPP_ENABLED = getEnvVar('VITE_EPP_ENABLED', 'epp_enabled_placeholder');

export const eppConfig = {
  enabled: EPP_ENABLED === 'true'
};

export const isEppEnabled = (): boolean => eppConfig.enabled;
